function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMccHotel = function SvgMccHotel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 8a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6a1 1 0 0 1 1-1h2a1 1 0 0 0 1-1v-9a6 6 0 0 0-6-6H23.055a4 4 0 0 0-3.859 2.947L17.273 22H5a1 1 0 0 1-1-1V9a1 1 0 0 0-1-1H1Zm15 7a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z",
    clipRule: "evenodd",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgMccHotel;